import React from 'react';
import { SpecialRatesGrid } from './SpecialRatesGrid';
import {
  getSpecialRatesGeneral,
  saveSpecialRatesGeneralBatch,
  addSpecialRatesGeneralRange,
} from '../../api/specialRatesGeneral';

export function SpecialRatesGeneralPage() {
  return (
    <SpecialRatesGrid
      resourceCode="specialRatesGeneral"
      titleKey="specialRates.generalPageTitle"
      getRows={getSpecialRatesGeneral}
      saveBatch={saveSpecialRatesGeneralBatch}
      addRange={addSpecialRatesGeneralRange}
    />
  );
}
